//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import headingMixin from '~/mixins/headingMixin'
import parseTextMixin from '~/mixins/parseTextMixin'

export default {
  mixins: [headingMixin, parseTextMixin],

  inheritAttrs: false,

  props: {
    cta: {
      type: Object,
      default: () => {}
    },

    copy: {
      type: String,
      default: ''
    },

    primaryColour: {
      type: String,
      default: 'white',
      validator: (value) => {
        return [
          'white',
          'black'
        ].includes(value)
      }
    }
  },

  data () {
    return {
      hasHover: false
    }
  },

  computed: {
    isSmallHeading () {
      return ['h3', 'h4', 'h5'].includes(this.headingSize)
    },
    classes () {
      return {
        Banner: true,
        [`Banner--${this.primaryColour}`]: this.primaryColour,
        'has-hover': this.hasHover
      }
    }
  },

  methods: {
    hasHoverOn () {
      this.hasHover = true
    },

    hasHoverOff () {
      this.hasHover = false
    }
  }
}
